import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Storage } from 'storage';
import { errorLogger } from 'utils/config/firebase/logs';

interface TranslationType {
    [key: string]: string;
}

interface Languages {
    main: {
        entries: {
            [key: string]: {
                v: string;
            };
        };
    };
}

const defaultLanguage = navigator.language;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {},
        lng: Storage.getItem('i18nextLng_custom') ?? defaultLanguage ?? 'en',
        fallbackLng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
    });

i18n.on('languageChanged', (lng) => {
    document.documentElement.setAttribute('lang', lng);
});

async function getLanguages() {
    try {
        const access_token = process.env.REACT_APP_APPLANGA_ACCESS_TOKEN;
        const app_id = process.env.REACT_APP_APPLANGA_APP_ID;
        const url = process.env.REACT_APP_APPLANGA_URL;
        const response = await fetch(`${url}?app=${app_id}`, {
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-type': 'application/json',
            },
        });
        const languages = await response.json();
        const data = languages.data;
        if (typeof data !== 'object') {
            return;
        }

        let languagesObj = {};
        for (const key in data) {
            const item = data[key] as Languages;
            languagesObj = {
                ...languagesObj,
                ...createLanguageFiles(key, item),
            };
        }
        const selectedLanguage = Storage.getItem('i18nextLng_custom') ?? defaultLanguage;

        if (!selectedLanguage) {
            return i18n.changeLanguage('en');
        }
        if (selectedLanguage in languagesObj) {
            return i18n.changeLanguage(selectedLanguage);
        }

        if (selectedLanguage.includes('-')) {
            const firstPart = selectedLanguage.split('-')[0];
            return i18n.changeLanguage(firstPart in languagesObj ? firstPart : 'en');
        }
        i18n.changeLanguage('en');
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'i18next -> getLanguages');
        }
    }
}

function createLanguageFiles(language: string, data: Languages) {
    try {
        const entries = data?.main?.entries;
        if (!entries) {
            return {};
        }
        const translation: TranslationType = {};

        for (const entriesKey in entries) {
            translation[entriesKey] = entries[entriesKey]?.v;
        }
        i18n.addResourceBundle(language, 'translation', translation, true, true);
        return { [language]: translation };
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'i18next -> createLanguageFiles');
        }
        console.log(error);
    }
}
getLanguages();

export default i18n;
